import { apiClient } from "../../api_client/api_client";
import { UserManager } from "./user.type";

const apiBaseUser = 'user';
const apiBaseUsers = 'users';

const UserApi = {

  getAllUsers: async (): Promise<any> => {
    return apiClient.get(`${apiBaseUser}/getUsers`);
  },

  getUsersByOrgAndRole: async (orgIds: string[], roleIds: string[]): Promise<any> => {
    return apiClient.get(`${apiBaseUser}/by-organization-role?organization_uuids=${orgIds}&role_codes=${roleIds}`);
  },

  getAllUsersByAcls: async (acls: string[]): Promise<any> => {
    return apiClient.get(`${apiBaseUser}/by-acls?acls=${acls}`);
  },

  getRecord: async (id: any): Promise<any> => {
    return apiClient.get(`${apiBaseUser}/workflow?id=${id}`);
  },

  getUserByUuid: async (uuid: string) => {
    return apiClient.get<UserManager>(`/users/${uuid}`);
  },

  getUserByEmail: async (email: string) => {
    return apiClient.get<UserManager>(`/users/by-email/${email}`);
  },

  customUpdate: async (data: any): Promise<any> => {
    return apiClient.put(`${apiBaseUser}/workflow`, data);
  }
}

export const UserService = {

  getAllUsers: async (): Promise<any> => {
    const users = await UserApi.getAllUsers();
    if(!users) return undefined;
    return users;
  },

  getUsersByOrgAndRole: async (orgIds: string[], roleIds: string[]): Promise<any> => {
    const users = await UserApi.getUsersByOrgAndRole(orgIds, roleIds);
    if(!users) return undefined;
    return users;
  },

  getAllUsersByAcls: async (acls: string[]): Promise<any> => {
    const users = await UserApi.getAllUsersByAcls(acls);
    if(!users) return undefined;
    return users;
  },

  getRecord: async (id: any): Promise<any> => {
    const user = await UserApi.getRecord(id);
    if(!user) return undefined;
    return user;
  },

  getUserByUuid: async (uuid: string): Promise<any> => {
    const user = await UserApi.getUserByUuid(uuid);
    if(!user) return undefined;
    return user;
  },

  getUserByEmail: async (email: any): Promise<any> => {
    const user = await UserApi.getUserByUuid(email);
    if(!user) return undefined;
    return user;
  },

  customUpdate: async (data: any): Promise<any> => {
    const response = await UserApi.customUpdate(data);
    if(!response) return null;
    return response;
  },
}